"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredGeneralLtlGs1BolInfo = void 0;
exports.RequiredGeneralLtlGs1BolInfo = {
    ProNumber: 'PRO_NUMBER',
    ReceivingStamp: 'RECEIVING_STAMP',
    TrailerNumber: 'TRAILER_NUMBER'
};
//# sourceMappingURL=required-general-ltl-gs1-bol-info.js.map